<template>
<v-app>
    <v-app-bar app color="primary" dark>
        <router-link class="d-flex align-center" to="/categories">
            <v-img alt="Vuetify Logo" class="shrink mr-2" contain src="./assets/app_icon.svg" transition="scale-transition" width="40" />
            <v-img alt="Vuetify Logo" class="shrink mr-2" contain src="./assets/kan_logo.svg" transition="scale-transition" width="40" />

        </router-link>
        <p class="ma-5">
            סטיקרים ורינגטונים
        </p>
        <v-spacer></v-spacer>

    </v-app-bar>

    <v-main class="main">
        <router-view />
    </v-main>
</v-app>
</template>

<script>

import * as firebase from "firebase/app";

export default {
    name: 'App',

    components: {
        
    },

    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                if (this.$route.path == "/") {
                    this.$router.push("categories")
                }
            } else if (this.$route.path != "/") {
                this.$router.push("/")
            }
        })

    },
};
</script>

<style scoped>
</style>
